import mobile_device_check from "mobile_detection"
import {Controller} from "@hotwired/stimulus"
import modal from "modal"

let has_been_seen = false

class BounceModalController extends Controller {
  connect() {
    if (mobile_device_check()) return

    document.addEventListener("mouseleave", this._callback.bind(this))
  }

  disconnect() {
    document.removeEventListener("mouseleave", this._callback)
  }

  _callback(e) {
    if (has_been_seen) return
    // will bounce the pop up when mouse is leaving the page
    // adapted from https://github.com/carlsednaoui/
    // bounce-exchange-alternative/blob/master/source/ouibounce.js#L2-L16
    if (e.clientY >= 5 || document.querySelector(".modal.in")) return

    has_been_seen = true
    modal("#training_cta_modal")
  }
}

export default BounceModalController
